var _path, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 489.7 489.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.9 28.6C109.8 28.6 0 125.6 0 244.8c0 47.1 17.6 93.2 49.7 130.6-6.7 14.8-16.5 26.5-29.3 34.8-6.6 4.3-9.8 12.1-8.1 19.8 1.7 7.6 7.8 13.2 15.6 14.3 7.7 1.1 15.6 1.6 23.3 1.6 24.8 0 47.4-5.3 67.3-15.8 38.1 20.3 81.6 31 126.3 31 135.1 0 244.9-97 244.9-216.2S380 28.6 244.9 28.6zm0 407.9c-42.9 0-84.5-10.8-120.3-31.2-1.9-1.1-4-1.6-6.1-1.6-2.2 0-4.4.6-6.3 1.7-18.8 11.3-41.4 16.7-66 15.8 12.9-11.6 22.7-26.3 29.3-44 1.6-4.3.6-9.2-2.5-12.6-31.8-34.3-48.5-75.7-48.5-119.8 0-105.7 98.9-191.7 220.4-191.7s220.4 86 220.4 191.7-98.9 191.7-220.4 191.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 244.8,
    cy: 244.8,
    r: 15.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.2,
    cy: 244.8,
    r: 15.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 312.4,
    cy: 244.8,
    r: 15.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSic);
export default __webpack_public_path__ + "static/media/sic.4c75c4d56281b77c7033903e79ba351a.svg";
export { ForwardRef as ReactComponent };